import './Description.scss';

const Description = function(props) {
	const content = document.querySelector('.tool-description')?.innerHTML || '';
	return (
		<div className="overlay">
			<div className="pop-up description">
				<button className="button-close" onClick={props.closeCallback}>×</button>
				<div className="tool-description" dangerouslySetInnerHTML={{__html: content}}></div>
			</div>
		</div>
	)
}

export default Description;